import { goto } from './../index'
import { GuideConfigItem } from '@/views/components/GuideRemind/js/type'
import { TABS } from '@/views/CreateSupplyList/js/constants'
import { ComponentInternalInstance } from 'vue'

interface Config {
  [propName: string]: (instance: ComponentInternalInstance | null) => GuideConfigItem
}
// key为route name
export const config: Config = {
  DeclareVariety: (instance: ComponentInternalInstance | null) => {
    return {
      lists: [
        {
          selector: '.declare-variety .search-panel',
          remindHtml:
            '在此处检索你需要申报的品种，如乐药已有经营，可以直接选择进行申报，如乐药尚未经营，需要手动填写商品信息进行申报。',
          positionY: 'bottom',
          offsetX: 0,
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.5,
              yValue: 0.5
            }
          ]
        },
        {
          selector: '.sp-dialog.confirm-report-dialog',
          overlaySelector: '.sp-overlay-dialog',
          remindHtml: '乐药已经营品种，匹配准确的乐药编码，完善相关申报信息后即可提交申报',
          positionY: 'bottom',
          offsetX: -120,
          showHighlightWrapper: false,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.58,
              yValue: 0.98
            }
          ],
          beforeCurStepFun: () => {
            instance && instance.exposed?.toggleConfirmReportVisible()
          }
        },
        {
          selector: '.sp-dialog.self-report-dialog',
          overlaySelector: '.sp-overlay-dialog',
          remindHtml: '乐药尚未经营品种，需要完善更多商品信息进行申报',
          positionY: 'bottom',
          offsetX: 200,
          showHighlightWrapper: false,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.61,
              yValue: 0.98
            }
          ],
          beforeCurStepFun: () => {
            instance && instance.exposed?.toggleConfirmReportVisible()
            instance && instance.exposed?.toggleSelfReportVisible()
          }
        }
      ],
      pageCompleteCallBackFun: () => {
        instance && instance.exposed?.toggleSelfReportVisible()
        goto('VarietyManagement')
      },
      skipCallBackFun: () => {
        location.reload()
      },
      isLastPage: false
    }
  },
  VarietyManagement: (instance: ComponentInternalInstance | null) => {
    return {
      lists: [
        {
          selector: '.ant-menu-item-selected.ant-menu-item-only-child',
          remindHtml:
            '已申报品种的进度可在当前页面查看，请在【查看进度】里看申报流程，并且根据待办流程进行操作或者联系业务人员推进流程。',
          positionY: 'bottom',
          offsetX: -120,
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.9,
              yValue: 0.5
            }
          ]
        },
        {
          selector: '.audit-status-orderable',
          remindHtml: '首次申报的品种子公司生码已经完成，可快捷链接至供货页面进行供货做单 ！',
          positionY: 'bottom',
          offsetX: -120,
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.8,
              yValue: 0.9
            }
          ]
        }
      ],
      skipCallBackFun: () => {
        instance && instance.exposed?.guideFinish()
        goto('DeclareVariety')
      },
      pageCompleteCallBackFun: () => {
        instance && instance.exposed?.guideFinish()
        goto('CreateSupplyList')
      },
      isLastPage: false
    }
  },
  CreateSupplyList: () => {
    return {
      lists: [
        {
          selector: '.ant-menu-item-selected.ant-menu-item-only-child',
          remindHtml: '申报通过的品种首次供货及后期补货补货，都需要在该页面创建供货单',
          positionY: 'bottom',
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.9,
              yValue: 0.5
            }
          ]
        },
        {
          selector: '.guide-remind-button-group',
          remindHtml: '选择本次补货的品种',
          positionY: 'bottom',
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.5,
              yValue: 0.9
            }
          ]
        }
      ],
      skipCallBackFun: () => {
        goto('DeclareVariety')
      },
      pageCompleteCallBackFun: () => {
        goto('CreateSupplyList', {
          assignTab: TABS.VARIETIES
        })
      },
      isLastPage: false
    }
  },
  ConfirmSupplyList: () => {
    return {
      lists: [
        {
          selector: '.guide-remind-button',
          remindHtml: '完善供货价格、数量等信息后在此页面确认生成供货单',
          positionY: 'bottom',
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.5,
              yValue: 1.2
            }
          ]
        }
      ],
      skipCallBackFun: () => {
        goto('DeclareVariety')
      },
      pageCompleteCallBackFun: () => {
        goto('SupplyRecord')
      },
      isLastPage: false
    }
  },
  SupplyRecord: () => {
    return {
      lists: [
        {
          selector: '.ant-menu-item-selected.ant-menu-item-only-child',
          remindHtml: '已创建供货单的品种进度可在当前页面查看',
          positionY: 'bottom',
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.9,
              yValue: 0.5
            }
          ]
        }
      ],
      skipCallBackFun: () => {
        goto('DeclareVariety')
      },
      isLastPage: true
    }
  },
  NoticeCenterList: (instance: ComponentInternalInstance | null) => {
    return {
      lists: [
        {
          selector: '.ant-layout-header .user-toolbar',
          remindHtml: '点击头像图标可进入消息中心<br/>小圆点数字：未读的消息通知',
          offsetX: -110,
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.5,
              yValue: 0.9
            }
          ]
        },
        {
          selector: '.notice-center .tab-wrapper .tab-item',
          remindHtml: '具体通知内容事项<br/>小圆点数字：未读的消息通知',
          positionX: 'right',
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.5,
              yValue: 1
            }
          ]
        },
        {
          selector: '.notice-center .table-wrapper',
          remindHtml:
            '未读订单通知<br/>查看详情：点击可跳转到订单查询页面</br>全部标记已读：可将未读订单全部标记已读',
          positionX: 'right',
          showHighlightWrapper: true,
          targetPadding: 15,
          spotPointLists: [
            {
              type: 'scale',
              xValue: 0.95,
              yValue: 0.2
            },
            {
              type: 'scale',
              xValue: 0.98,
              yValue: 0.8
            }
          ]
        }
      ],
      pageCompleteCallBackFun: () => {
        instance && instance.exposed?.onGuideFinished()
        goto('NoticeCenterList')
      },
      skipCallBackFun: () => {
        instance && instance.exposed?.onGuideFinished()
        goto('NoticeCenterList')
      },
      isLastPage: true
    }
  }
}
